import { useParams } from 'react-router-dom';
import PostAnalysis from './PostAnalysis';

export default function PostAnalysisRoute() {
  const { postId } = useParams<{ postId: string }>();
  if (!postId) return null;
  return <PostAnalysis postId={postId} />;
}
